<template>
  <div class="promotion-popup">
    <popup :buttons="buttons" :close-action="closeModal">
      <template v-slot:title>
        <div class="promotion-title">
          <img class="logo-image" :src="require('@/assets/promotions/promo-popup-image.svg')">
          <div class="popup-title">מגיעה לך הטבה בלעדית,</div>
          <div class="popup-title">{{monthsText}} riseup במתנה!</div>
        </div>
      </template>
      <template v-slot:content>
        <div class="description">
          <div>נרשמים למנוי בשירות ונהנים</div>
          <div>  מ{{monthsText}} {{extra}}
            <span class="bold">ללא תשלום </span>
          </div>
        </div>
      </template>
    </popup>
  </div>
</template>

<script>
import BaseUI from 'base-ui';
import { mapState, mapGetters } from 'vuex';
import Segment from '../../Segment';

export default {
  name: 'PromotionDuringOnboardingPopup',
  components: {
    Popup: BaseUI.Popup,
  },
  created() {
    Segment.trackUserGot('PromotionDuringOnboarding');
  },
  computed: {
    ...mapState('benefits', ['benefitAmount']),
    ...mapGetters('benefits', ['monthsText']),
    extra() {
      if (this.benefitAmount === 1) {
        return 'נוסף';
      }
      return 'נוספים';
    },

    buttons() {
      return [
        {
          title: 'מצויין, תודה!',
          action: this.closeModal,
          size: 'slim',
        },
      ];
    },
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>

  .promotion-popup {
    .promotion-title {
      text-align: center;
      .popup-title {
        font-family: SimplerPro;
        font-weight: bold;
        font-size: 24px;
        line-height: 30px;
      }

      .logo-image {
        text-align: center;
        height: 106px;
        width: 106px;
        margin: 30px;
      }
    }
    .description {
      font-family: SimplerPro;
      margin-bottom: 50px;
      line-height: 1.38;
      text-align: center;

      .bold {
        font-weight: bold;
      }
    }
  }
</style>
